const ButtonResults = ({label,callback}) => {
    const clickEvent = ()=>{
        callback();
    }

  return (
    <button
      type="button"
      className="button button--secondary"
      onClick={clickEvent}
    >
      {label}
    </button>
  );
};
export default ButtonResults;
